<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('admin.content.recruit.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.content.recruit.add.title.edit', { name: columnTitle }) : $t('admin.content.recruit.add.title.create', { name: columnTitle }) }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.content.recruit.add.form.basicInfo') }}</div>
      <div class="list_wrap">
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.title.label')" :colon="false">
            <a-textarea
              class="testArea"
              :placeholder="$t('admin.content.recruit.add.form.title.placeholder')"
              maxLength="50"
              v-decorator="['title', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.title.required') }] }]"
            ></a-textarea>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.duties.label')" :colon="false">
            <a-textarea
              class="testArea"
              :placeholder="$t('admin.content.recruit.add.form.duties.placeholder')"
              maxLength="500"
              v-decorator="['duties', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.duties.required') }] }]"
            ></a-textarea>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.salary.label')" :colon="false">
            <div class="d-flex">
              <a-select
                allowClear
                v-decorator="['salary', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.salary.required') }] }]"
                :placeholder="$t('admin.content.recruit.add.form.salary.placeholder')"
              >
                <a-select-option value="1">{{ $t('admin.content.recruit.add.form.salary.options.negotiate') }}</a-select-option>
                <a-select-option value="2">{{ $t('admin.content.recruit.add.form.salary.options.custom') }}</a-select-option>
              </a-select>
              <div class="d-flex money" v-if="form.getFieldValue('salary') === '2'">
                <a-form-item>
                  <a-input
                    :suffix="$t('admin.content.recruit.add.form.salary.custom.unit')"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :placeholder="$t('admin.content.recruit.add.form.salary.custom.min.placeholder')"
                    maxLength="6"
                    v-decorator="['salary_custom_min', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.salary.custom.min.required') }] }]"
                  ></a-input>
                </a-form-item>
                <span> - </span>
                <a-form-item allow-clear>
                  <a-input
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :suffix="$t('admin.content.recruit.add.form.salary.custom.unit')"
                    :placeholder="$t('admin.content.recruit.add.form.salary.custom.max.placeholder')"
                    maxLength="6"
                    v-decorator="['salary_custom_max', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.salary.custom.max.required') }] }]"
                  ></a-input>
                </a-form-item>
              </div>
            </div>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.positions.label')">
            <a-input
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('admin.content.recruit.add.form.positions.placeholder')"
              maxLength="6"
              v-decorator="['number_of_positions', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.positions.required') }] }]"
            ></a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.education.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['education_requirements', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.education.required') }] }]"
              :placeholder="$t('admin.content.recruit.add.form.education.placeholder')"
            >
              <a-select-option value="1">{{ $t('admin.content.recruit.add.form.education.options.college') }}</a-select-option>
              <a-select-option value="2">{{ $t('admin.content.recruit.add.form.education.options.bachelor') }}</a-select-option>
              <a-select-option value="3">{{ $t('admin.content.recruit.add.form.education.options.master') }}</a-select-option>
              <a-select-option value="4">{{ $t('admin.content.recruit.add.form.education.options.phd') }}</a-select-option>
              <a-select-option value="5">{{ $t('admin.content.recruit.add.form.education.options.postdoc') }}</a-select-option>
              <a-select-option value="6">{{ $t('admin.content.recruit.add.form.education.options.any') }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full full_op" :label="$t('admin.content.recruit.add.form.major.label')" :colon="false">
            <a-select
              mode="multiple"
              allowClear
              v-decorator="['major_ids', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.major.required') }] }]"
              :placeholder="$t('admin.content.recruit.add.form.major.placeholder')"
            >
              <a-select-option v-for="item in specialityList" :key="item.id" :value="item.id">{{
                item.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.time.label')" :colon="false">
            <a-range-picker
              style="width: 100%;"
              allowClear
              v-decorator="[
                'application_time',
                { rules: [{ required: true, message: $t('admin.content.recruit.add.form.time.required') }] }
              ]"
            >
              <a-icon slot="suffixIcon" style="color: #7C8491" type="down" />
            </a-range-picker>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.recruit.add.form.status.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['status', { rules: [{ required: true, message: $t('admin.content.recruit.add.form.status.required') }] }]"
              :placeholder="$t('admin.content.recruit.add.form.status.placeholder')"
            >
              <a-select-option value="1">{{ $t('admin.content.recruit.add.form.status.options.open') }}</a-select-option>
              <a-select-option value="2">{{ $t('admin.content.recruit.add.form.status.options.close') }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>

      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.content.recruit.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import {
  getPortalSubcolumnTopList,
  postportalSubcolumnSave,
  getPortalJobDetail
} from '@/api/admin'
import moment from 'moment/moment'

export default {
  data() {
    return {
      id: undefined,
      columnId: undefined,
      form: this.$form.createForm(this),
      specialityList: [],
      columnTitle: this.$route.query.columnTitle
    }
  },
  methods: {
    back() {
      // this.$router.push({
      //   name: 'teacherList'
      // })
      this.$router.go(-1)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          if (this.id) {
            values.id = this.id
          }
          values.column_id = this.columnId
          values.application_start_date = moment(moment(values.application_time[0]._d).format('YYYY-MM-DD')).format(
            'YYYY-MM-DD'
          )
          values.application_end_date = moment(moment(values.application_time[1]._d).format('YYYY-MM-DD')).format(
            'YYYY-MM-DD'
          )
          console.log(values.salary_custom_max)
          console.log(values.salary_custom_min)
          if (Number(values.salary_custom_max) < Number(values.salary_custom_min)) {
            this.$message.error(this.$t('admin.content.recruit.add.messages.salaryError'))
            return
          }

          postportalSubcolumnSave(values).then(res => {
            if (res.code == 200) {
              const tip = this.id ? 
                this.$t('admin.content.recruit.add.messages.editSuccess') : 
                this.$t('admin.content.recruit.add.messages.createSuccess')
              this.$message.success(tip)
              this.$router.go(-1)
            }
          })
        }
      })
    },
    getTrainingEquipmentDetailHttp() {
      getPortalJobDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          console.log(res.data)
          this.form.setFieldsValue({
            title: res.data.title,
            duties: res.data.duties,
            salary: res.data.salary,
            number_of_positions: res.data.numberOfPositions,
            education_requirements: res.data.educationRequirements,
            major_ids: res.data.majorIds,
            application_time: [moment(res.data.applicationStartDate), moment(res.data.applicationEndDate)],
            status: res.data.status.toString()
          })
          if (res.data.salary == 2) {
            setTimeout(() => {
              this.form.setFieldsValue({
                salary_custom_min: res.data.salaryCustomMin,
                salary_custom_max: res.data.salaryCustomMax
              })
            }, 50)
          }
        }
      })
    },
    getPortalSubcolumnTopListHttp() {
      getPortalSubcolumnTopList().then(res => {
        if (res.code == 200) {
          console.log(res.data)
          this.specialityList = res.data.list
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.columnId = this.$route.query.columnId || undefined
    // 专业
    this.getPortalSubcolumnTopListHttp()
    if (this.id) {
      this.getTrainingEquipmentDetailHttp()
    }
  }
}
</script>

<style lang="less" scoped>
.list_wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list {
    width: 50%;
    display: flex;
    //padding-right: 200px;
    .ant-form-item-label label {
      color: #000000;
    }
    .ant-form-item {
      width: 100%;
      padding-left: 45px;
      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      //border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      //border-radius: 20px;
    }
    .ant-select-selection--single {
      height: 36px;
      line-height: 36px;
    }
    .ant-select-selection--single .ant-select-selection__rendered {
      line-height: 36px;
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button {
    margin-top: 5%;
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
/deep/ .ant-form .list .ant-form-item-label label {
  font-weight: 600;
}
/deep/.testArea {
  min-height: 60px !important;
  max-height: auto !important;
  overflow: auto;
  resize: none;
}
/deep/.ant-form-item-control {
  line-height: 0;
}
.d-flex {
  display: flex;
}
.money {
  width: 104%;
  margin-left: 32px;
  span {
    display: inline-block;
    margin-right: 10px;
    margin-left: 5px;
    line-height: 40px;
  }
}
/deep/ .money .ant-form-item {
  padding-right: 5px !important;
  padding-left: 0px !important;
}
.full_op /deep/.ant-select {
  width: 100%;
  min-height: 35px !important;
  height: auto !important;
  color: #000000;
  margin-right: 0;
  //border-radius: 20px;
}
</style>
